// extracted by mini-css-extract-plugin
var _1 = "fmz5B8qo";
var _2 = "D8rg6zos";
var _3 = "immPjiaK";
export { _1 as "caption", _2 as "drink", _3 as "info" }
